import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './core/services/session-service';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './shared/loader/loader.component';
import { AlertComponent } from './shared/alert/alert.component';
import { HeaderComponent } from './shared/header/header.component';
import { MatDialog } from '@angular/material/dialog';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LoaderComponent,
    AlertComponent,
    HeaderComponent
  ]
})
export class AppComponent implements OnInit {

  loggedIn: Boolean = false;
  redirectingToLogin: Boolean = false;
  redirectingToHome: Boolean = false;
  title: string = 'Talent Hunt';

  subscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private sessionService: SessionService,
    private dialog: MatDialog) {
  }
  
  ngOnInit() {
    this.registerListeners();
    this.sessionService.getLoginState();
  }

  registerListeners(): void {

    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !this.router.navigated;
      }
      if (event instanceof NavigationEnd) {
        this.updatePageTitle(this.route);
      }
    });
    

    this.sessionService.onLoggedInStateChange.subscribe(loggedIn => {
      if (!loggedIn) {
        this.dialog.closeAll();
      }

      this.redirectingToHome = loggedIn;
      this.redirectingToLogin = !loggedIn;
      this.loggedIn = loggedIn;
    });
    
  }

  private getLastChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if(route.firstChild) {
      return this.getLastChild(route.firstChild);
    } else {
      return route;
    }
  }

  private updatePageTitle(route: ActivatedRoute) {
    let title = '';
    
    route.data.subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      title = this.getLastChild(root).data['title'];
    });

    if(!!title) {
      this.title = title;
    }

    this.titleService.setTitle(this.title);
  }
}
